import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const Icon = ({ icon, prefix = 'fas', size = 'lg' }) => <FontAwesomeIcon icon={[prefix, icon]} size={size} />;

export default Icon;
